// import { track } from './../sendData';

export default class Click {
  add(entry: { el: Element }) {
    let tp = {};
    try {
      tp = JSON.stringify(entry.el.getAttribute('track-params'));
    } catch (error) {
      console.log(error);
      tp = {};
    }
    entry.el.addEventListener('click', function () {
      console.log(`Click data to server: ${tp}`);
      // track(tp);
    });
  }
}
